module.exports = __webpack_public_path__ + "assets/img/topImg3.65aebb77.png";